import React, { useRef, useState } from "react";
import { CrossIcon } from "../../common/icons";

const ProductionHeader: React.FC = () => {
  const [showBanner, setShowBanner] = useState(true);
  const bannerRef = useRef<HTMLDivElement | null>(null);

  // const handleClose = () => {
  //   setIsVisible(false);
  // };

  const handleSwitchToBeta = () => {
    window.open(
      "https://legacy.timescoursefinder.com/",
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <>
      {showBanner && (
        <div
          ref={bannerRef}
          className="bg-[#F6F6FF] mt-[13px] py-2 px-4 items-center justify-center w-full flex relative"
        >
          <div className="flex items-center">
            <img
              src="/images/header.png"
              alt="Beta Icon"
              className="w-10 h-10"
            />
            <span className="text-title text-xs md:text-sm font-medium pl-4 leading-tight xl:leading-6 pr-5">
              Miss the old version? No worries, it&apos;s just a click away.
            </span>
          </div>
          <div className="flex items-center">
            <button
              onClick={handleSwitchToBeta}
              className="bg-[#3F2567] w-[100px] md:w-full text-white font-medium text-xs md:text-sm py-2 px-4 rounded-full mr-2 shadow-md"
            >
              Switch back
            </button>
          </div>
          <button
            onClick={() => setShowBanner(false)}
            className="absolute right-0  md:right-2 top-1/2 -translate-y-1/2 rounded-full md:p-2 hover:bg-primary-10 text-lg font-bold "
            aria-label="Close banner"
          >
            <CrossIcon />
          </button>
        </div>
      )}
    </>
  );
};

export default ProductionHeader;
